import { namespace } from 'vuex-class';
import { ICreateFieldState } from './create-field.types';

export const CreateField = namespace('dealroom/fields/createField');

export enum ECreateFieldAction {
  DropCreate = 'dropCreate',
  ClickCreate = 'clickCreate',
  Create = 'create',
  CreateFailed = 'createFailed',
  Duplicate = 'duplicate',
  DuplicateFailed = 'duplicateFailed',
  Reset = 'reset',
}

export enum ECreateFieldMutation {
  SetOptimisticallyCreatedFields = 'setOptimisticallyCreatedFields',
  SetUnsuccessfullyCreatedFields = 'setUnsuccessfullyCreatedFields',
  SetCreatedFieldsData = 'setCreatedFieldsData',
  SetState = 'setState',
}

export const state: ICreateFieldState = {
  optimisticallyCreatedFields: [],
  unsuccessfullyCreatedFields: [],
  createdFieldsData: [],
};
